import { useEffect, useState } from "react";
import axios from "axios";
import { CITY_BLUR, REGION } from "../../lib/troy";
import { Users, Star, Timer } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function About() {
  const [stats, setStats] = useState({
    passengers_served: 1000,
    drivers_registered: 0,
    avg_rating: 4.9,
  });

  useEffect(() => {
    axios
      .get(`${API}/stats`)
      .then((r) => setStats(r.data))
      .catch(() => {});
  }, []);

  return (
    <section
      id="sobre"
      data-testid="about-section"
      className="relative py-24 md:py-32 overflow-hidden"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 grid lg:grid-cols-12 gap-12 items-center">
        <div className="lg:col-span-6">
          <p className="text-xs tracking-[0.25em] uppercase text-[#FFCC00] font-bold mb-4">
            Sobre o grupo
          </p>
          <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl font-black leading-tight tracking-tighter text-balance">
            Mobilidade urbana feita pra{" "}
            <span className="text-[#FFCC00]">General Carneiro</span> e regiões próximas.
          </h2>
          <p className="mt-6 text-white/70 text-lg leading-relaxed">
            A Troy Transportes é um{" "}
            <strong className="text-white">grupo de transporte</strong> focado em
            agilidade, segurança e preço justo. Atendemos bairros locais com
            motoristas verificados, oferecendo uma alternativa direta — e mais
            humana — aos apps tradicionais.
          </p>
          <p className="mt-4 text-white/60 leading-relaxed">
            Chamou no grupo, a Troy responde. Sem filas de algoritmo, sem
            dinâmica inflando preço na hora do rush. Só corrida boa, no tempo
            certo, com quem você pode confiar — e ainda{" "}
            <span className="text-[#FFCC00] font-semibold">concorrendo a prêmios todo mês</span>.
          </p>

          <div className="mt-8 flex flex-wrap gap-3">
            {["Bairros locais", "Preço justo", "Sem surge", "Atendimento direto", "Prêmios mensais"].map(
              (t) => (
                <span
                  key={t}
                  className="px-4 py-2 rounded-full bg-white/5 border border-[#FFCC00]/15 text-sm text-white/80"
                >
                  {t}
                </span>
              )
            )}
          </div>
        </div>

        <div className="lg:col-span-6 relative">
          <div className="relative aspect-[4/5] rounded-3xl overflow-hidden border border-[#FFCC00]/15">
            <img
              src={CITY_BLUR}
              alt="Carro da Troy em movimento pela cidade"
              className="absolute inset-0 w-full h-full object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black via-black/40 to-transparent" />
          </div>

          {/* Floating stats */}
          <div
            data-testid="about-stats"
            className="absolute -left-2 md:left-6 -bottom-6 md:bottom-10 grid grid-cols-3 gap-2 md:gap-4 w-[calc(100%+16px)] md:w-[110%]"
          >
            <StatCard
              icon={<Users className="w-4 h-4" />}
              label="Passageiros"
              value={`+${stats.passengers_served.toLocaleString("pt-BR")}`}
              testid="stat-passengers"
              accent="#FFCC00"
            />
            <StatCard
              icon={<Star className="w-4 h-4" />}
              label="Avaliação"
              value={`${stats.avg_rating}★`}
              testid="stat-rating"
              accent="#FF3B30"
            />
            <StatCard
              icon={<Timer className="w-4 h-4" />}
              label="Resposta"
              value="< 2 min"
              testid="stat-response"
              accent="#FFCC00"
            />
          </div>
        </div>
      </div>
    </section>
  );
}

function StatCard({ icon, label, value, testid, accent }) {
  return (
    <div
      data-testid={testid}
      className="rounded-2xl bg-[#18181C] border border-[#FFCC00]/15 p-3 md:p-5 backdrop-blur-xl"
    >
      <div
        className="inline-flex items-center justify-center w-7 h-7 md:w-9 md:h-9 rounded-lg mb-2"
        style={{ background: `${accent}22`, color: accent }}
      >
        {icon}
      </div>
      <div className="font-display text-lg md:text-2xl font-black">{value}</div>
      <div className="text-[10px] md:text-xs uppercase tracking-wider text-white/50">
        {label}
      </div>
    </div>
  );
}
